import { render, staticRenderFns } from "./BasicIconMessage.vue?vue&type=template&id=c1ed24b0&scoped=true&"
import script from "./BasicIconMessage.vue?vue&type=script&lang=ts&"
export * from "./BasicIconMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ed24b0",
  null
  
)

export default component.exports